"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WebhookEventTypes = ['Announcement.created', 'Announcement.deleted', 'Announcement.updated', 'CheckIn.created', 'Comment.created', 'Customer.chatCreated', 'Customer.chatEnded', 'Customer.created', 'Customer.fileAdded', 'Customer.fileRemoved', 'CustomerUrl.created', 'CustomerUrl.deleted', 'Customer.updated', 'Invitation.accepted', 'Memo.created', 'Memo.shared', 'OrganisationFeedback.created', 'Question.created', 'QuestionAnswer.created'];
